import React, { useEffect, useState } from 'react';
import './Splash.css';

const SPLASH_DURATION_MS = 2200;
const FADE_OUT_MS = 400;

function Splash({ onFinish }) {
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    const hideTimer = setTimeout(() => setHiding(true), SPLASH_DURATION_MS);
    const removeTimer = setTimeout(onFinish, SPLASH_DURATION_MS + FADE_OUT_MS);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [onFinish]);

  return (
    <div className={`splash-overlay${hiding ? ' splash-overlay--hidden' : ''}`}>
      <img src="/splash.png" alt="Preparate Questões" className="splash-logo" />
      <span className="splash-tagline">Sua aprovação começa aqui</span>
      <div className="splash-progress">
        <div className="splash-progress-bar" />
      </div>
    </div>
  );
}

export default Splash;
